import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MISSION_XP = {
  quiz: 50,
  career: 30,
  dream: 20,
  learn: 25,
  strength: 40
};

export async function completeMission(token, missionId) {
  const xp = MISSION_XP[missionId] || 0;
  try {
    await axios.post(`${API}/missions/complete`, {
      mission_id: missionId,
      xp_earned: xp
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    toast.success(`Quest complete! +${xp} XP`, { duration: 3000 });
    return true;
  } catch (error) {
    return false;
  }
}
